module.exports = __webpack_public_path__ + "static/media/applenav-watch.af44edde.PNG";